import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SocketContext } from '../../contexts/SocketContext';
import { AlertContext } from '../../contexts/AlertContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import notAvailableImage from '../../assets/img/placeholder.png';
import { Actions } from '../../components/activos/inactivos/Actions';
import dayjs from 'dayjs';

const columns = [
    { id: "imagen", label: "", minWidth: 70, align: 'center' },
    { id: "placa", label: "Placa", minWidth: 70, align: 'center' },
    { id: "descripcion", label: "Descripción", minWidth: 100, align: 'center' },
    { id: "categoria", label: "Categoría", minWidth: 100, align: 'center' },
    { id: "baja", label: "Fecha de baja", minWidth: 100, align: 'center' },
    { id: "acciones", label: "Acciones", minWidth: 170, align: 'center' }
];

export const useInactiveAssets = () => {

    const [assets, setAssets] = useState([]);
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;

        subscribed && getAssets();

        return () => subscribed = false;
    }, []);

    const searchAsset = (value) => { 
        socket.emit('frontend:buscar-activo', { placa: value?.trim(), baja: true }, response => {
            const { ok, message, data } = response;

            if(!ok) return alertRef.current?.handleOpen('error', message);
          
            setAssets(data?.map(generatedPayload));
        });
    }

    const getAssets = useCallback(() => {
        setOpenLoader(true);
        socket.emit('frontend:obtener-activos', { "baja.estado": true }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }

            setAssets(data?.map(generatedPayload));
            setOpenLoader(false);
        });
    }, []);

    const generatedPayload = (data) => ({
        ...data,
        imagen: <img src={ data?.imagen?.secure_url ?? notAvailableImage } alt='image' style={{ width: 40, borderRadius: '50%' }} />,
        placa: data?.placa,
        descripcion: convertirLetraMayus(data?.descripcion),
        categoria: convertirLetraMayus(data?.categoria?.nombre),
        baja: dayjs(data?.baja?.fecha).format('DD-MM-YYYY'),
        acciones: <Actions data={ data } />
    });

    return {
        columns,
        assets,
        searchAsset
    }
}